import {
  saleDetailsFragment,
  saleListFragment,
  voucherDetailsFragment,
  voucherFragment
} from "@saleor/fragments/discounts";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { TypedQuery } from "../queries";
import { Languages, LanguagesVariables } from "./types/Languages";
import { SaleDetails, SaleDetailsVariables } from "./types/SaleDetails";
import { SaleList, SaleListVariables } from "./types/SaleList";
import { VoucherById, VoucherByIdVariables } from "./types/VoucherByid";
import {
  VoucherDetails,
  VoucherDetailsVariables
} from "./types/VoucherDetails";
import { VoucherList, VoucherListVariables } from "./types/VoucherList";

export const saleList = gql`
  ${pageInfoFragment}
  ${saleListFragment}
  query SaleList(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filter: SaleFilterInput
    $sort: SaleSortingInput
  ) {
    sales(
      after: $after
      before: $before
      first: $first
      last: $last
      filter: $filter
      sortBy: $sort
    ) {
      totalCount
      edges {
        node {
          ...SaleListFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export const useSaleListQuery = makeQuery<SaleList, SaleListVariables>(
  saleList
);

export const voucherList = gql`
  ${pageInfoFragment}
  ${voucherFragment}
  query VoucherList(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filter: VoucherFilterInput
    $sort: VoucherSortingInput
  ) {
    vouchers(
      after: $after
      before: $before
      first: $first
      last: $last
      filter: $filter
      sortBy: $sort
    ) {
      totalCount
      edges {
        node {
          ...VoucherFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export const useVoucherListQuery = makeQuery<VoucherList, VoucherListVariables>(
  voucherList
);

export const saleDetails = gql`
  ${saleDetailsFragment}
  query SaleDetails(
    $id: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    sale(id: $id) {
      ...SaleDetailsFragment
    }
  }
`;
export const TypedSaleDetails = TypedQuery<SaleDetails, SaleDetailsVariables>(
  saleDetails
);

const voucherDetails = gql`
  ${voucherDetailsFragment}
  query VoucherDetails(
    $id: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    voucher(id: $id) {
      ...VoucherDetailsFragment
    }
  }
`;
export const TypedVoucherDetails = TypedQuery<
  VoucherDetails,
  VoucherDetailsVariables
>(voucherDetails);

const voucherById = gql`
  query VoucherById($id: ID!) {
    voucher(id: $id) {
      id
      name
    }
  }
`;
export const useVoucherbyId = makeQuery<VoucherById, VoucherByIdVariables>(
  voucherById
);

const languages = gql`
  ${pageInfoFragment}
  query Languages($first: Int, $after: String) {
    languages(first: $first, after: $after) {
      totalCount
      edges {
        node {
          language
          languageCode
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export const useLanguagesQuery = makeQuery<Languages, LanguagesVariables>(
  languages
);
